var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4B4F54",
    strokeWidth: 1.059
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.807 9.905c0 4.904-3.986 8.88-8.903 8.88C4.986 18.784 1 14.808 1 9.904s3.986-8.88 8.904-8.88 8.903 3.976 8.903 8.88ZM10.144 1.025v17.759"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1 9.905 17.153.049M2.733 4.972l14.4.001M2.444 14.345l15.035-.051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.957 9.905c0 4.904-2.155 8.88-4.813 8.88s-4.812-3.976-4.812-8.88 2.154-8.88 4.812-8.88 4.813 3.976 4.813 8.88Z"
  }))));
};
export default SvgGlobe;